<hazmatsuite-next-stepper
  [async]="false"
  [steps]="(stepperItems$ | async) || []"
  (selectStep)="selectStep($event)"
></hazmatsuite-next-stepper>

<router-outlet></router-outlet>

<hazmatsuite-next-loading-spinner
  [isLoading]="isLoading$"
></hazmatsuite-next-loading-spinner>
